import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  static outlets = ["fonts--site-font"];

  applyChanges() {
    this.fontsSiteFontOutlet.setSiteFontsPreview();
    this.fontsSiteFontOutlet.hidePreviewActionBtns();
    app.view_panel.notify("The font selection has been applied to the site.");
  }

  notifyAndDiscardChanges() {
    this.fontsSiteFontOutlet.discardChanges();
    app.view_panel.notify("The font selection has been discarded.");
  }
}
